module.exports = "/_next/static/images/visacard-monotone-4b70bea1963503a3a010da66e0a91dd4.svg";